import { createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../../actions/SetDefinitions';
const adapter = createEntityAdapter({
    selectId: (x) => x.id,
    sortComparer: (a, b) => {
        const diff = a.ord - b.ord;
        if (diff == 0) {
            return a.title.localeCompare(b.title);
        }
        else {
            return diff;
        }
    },
});
export const panelGroupsSlice = createSlice({
    name: 'panel_groups',
    initialState: adapter.getInitialState(),
    reducers: {
        panelGroupsCleared(s) {
            adapter.removeAll(s);
        },
        panelGroupDeleted(s, action) {
            adapter.removeOne(s, action.payload);
        },
        panelGroupUpdated(s, action) {
            adapter.setOne(s, action.payload);
        }
    },
    extraReducers: builder => {
        builder
            .addCase(setDefinitions, (s, action) => {
            adapter.setAll(s, action.payload.panel_groups);
        });
    },
});
export const { panelGroupsCleared, panelGroupDeleted, panelGroupUpdated, } = panelGroupsSlice.actions;
export const panelGroupAdded = panelGroupUpdated;
export default panelGroupsSlice.reducer;
export const allPanelGroups = adapter.getSelectors().selectAll;
export const panelGroups = createSelector.withTypes()([
    s => s.ids,
    s => s.entities,
    (s, panelId) => panelId,
], (ids, entities, panelId) => {
    return ids.map(id => entities[id]).filter(x => x != undefined && x.panel_id == panelId);
});
